// New Component: AndrologyReportCard.js
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  Grid,
  CardContent,
  Stepper,
  Step,
  StepLabel,
} from '@mui/material';
import { styled } from '@mui/system';
import { toast } from 'sonner';
import {
  createDFIReport,
  createHSAReport,
  createIUIReport,
  createQSAReport,
  createSFRReport,
  downloadReport,
  sendDFIReport,
  sendHSAReport,
  sendIUIReport,
  sendQSAReport,
  sendSFRReport,
} from '../../../../api/andrologyApi';
import { useDispatch } from 'react-redux';
import {
  resetAndrologyData,
  setAndrologyData,
} from '../../../../actions/andrologyAction';
import { downloadReports, handlePreviewPDFFile } from '../../../../api/utils';
import AndrologyReport from './AndrologyReport';
import { Modal } from 'react-bootstrap';
import FreezingInventory from './freezingInventory';
import { initialState } from '../../../../reducers/andrologyReducer';
const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  borderRadius: '8px',
  marginTop: theme.spacing(3),
}));

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3),
  border: '1px solid #ddd',
  borderRadius: '8px',
}));

const steps = [
  'Sample Collected',
  'Received by Lab',
  'Report Generated',
  'Report Delivered',
];

const buttonsForSteps = ['Sample Collected', 'Received by Lab'];
const buttonsKeysForReducer = ['sampleCollectedAt', 'receivedByLabAt'];

export default function AndrologyReportCard({
  reportData,
  selectedPatientData,
  activeForm,
  setIsReportSelected,
  setSelectedProcess,
  setIsFreezingInventory,
  setSelectedSfrIdForFreezingInventory,
  setIsPregnancyDetails,
  setSelectedIuiIdForPregnancyDetails,
}) {
  const [activeStep, setActiveStep] = useState(0);
  const [stepDates, setStepDates] = useState({});
  const [modifiedBy, setModifiedBy] = useState(null);
  const [stepButtonsDisabled, setStepButtonsDisabled] = useState(false);
  const [showStepperAndFollowing, setShowStepperAndFollowing] = useState(true); // New state to control Stepper visibility
  const [createChildReport, setCreateChildReport] = useState(false);
  const [activeChildReport, setActiveChildReport] = useState(null);
  const [showHistoryOfChildReports, setShowHistoryOfChildReports] =
    useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  // const [isFreezingInventory, setIsFreezingInventory] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      reportData &&
      (reportData.isReportStarted ||
        reportData.sampleCollectedAt ||
        reportData.receivedByLabAt)
    ) {
      updateSteps(reportData);
    }
    // else {
    //   // setShowStepperAndFollowing(false); // Hide Stepper if condition is false
    //   if (reportData?.relatedSfrs && reportData?.relatedSfrs.length > 0) {
    //     // Sort relatedSfrs by createdAt in descending order
    //     const sortedRelatedSfrs = reportData.relatedSfrs.sort(
    //       (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    //     );
    //     // Set the most recent report as the active child report
    //     setActiveChildReport(sortedRelatedSfrs[0]);
    //     updateSteps(sortedRelatedSfrs[0]);
    //     setCreateChildReport(true)
    //   } else {
    //     setCreateChildReport(true);
    //     setActiveChildReport(reportData);
    //     updateSteps(reportData);
    //   }
    // }
  }, [reportData]);

  const updateSteps = (data) => {
    const newStepDates = {};
    let newActiveStep = 0;

    if (data.sampleCollectedAt) {
      const sampleCollectedAt = new Date(data.sampleCollectedAt);
      newStepDates[0] = sampleCollectedAt.toLocaleString();
      newActiveStep = 1;
    }

    if (data.receivedByLabAt) {
      const receivedByLabAt = new Date(data.receivedByLabAt);
      newStepDates[1] = receivedByLabAt.toLocaleString();
      newActiveStep = 2;
    }

    if (data.reportId) {
      //   newStepDates[2] = data.isReportStarted;
      newActiveStep = 3;
    }

    if (data.isReportDelivered) {
      newStepDates[3] = data.isReportDelivered;
      newActiveStep = 4;
    }
    setModifiedBy(data.modifiedBy);
    setStepDates(newStepDates);
    setActiveStep(newActiveStep);
  };

  const handleStepComplete = async (index) => {
    setStepButtonsDisabled(true);
    const currentDate = new Date().toISOString();
    setStepDates((prev) => ({
      ...prev,
      [index]: currentDate,
    }));

    if (reportData && activeStep < 2) {
      dispatch(
        setAndrologyData(
          `${activeForm}.${buttonsKeysForReducer[activeStep]}`,
          currentDate,
        ),
      );
      let response;
      switch (activeForm) {
        case 'hsa':
          const hsaKey = buttonsKeysForReducer[activeStep];
          response = await createHSAReport(selectedPatientData.patient.id, {
            ...reportData,
            [hsaKey]: currentDate,
          });
          //   if (!hsaRes) {
          //     setStepButtonsDisabled(false);
          //     dispatch(resetAndrologyData());
          //   }

          break;
        case 'dfi':
          const dfiKey = buttonsKeysForReducer[activeStep];
          response = await createDFIReport(selectedPatientData.patient.id, {
            ...reportData,
            [dfiKey]: currentDate,
          });
          //   console.log('dfiRes', dfiRes);
          //   dispatch(setAndrologyData('dfi', dfiRes.dfi));
          break;
        case 'qsa':
          const qsaKey = buttonsKeysForReducer[activeStep];
          // Assuming you have a similar update function for QSA
          response = await createQSAReport(selectedPatientData.patient.id, {
            ...reportData,
            [qsaKey]: currentDate,
          });
          //   dispatch(setAndrologyData('qsa', qsaRes.qsa));
          break;
        case 'sfr':
          const sfrKey = buttonsKeysForReducer[activeStep];
          // Assuming you have a similar update function for QSA
          if (createChildReport) {
            const parentId = reportData.id;
            const childReportData = {
              ...activeChildReport,
              parentId,
              [sfrKey]: currentDate,
            };
            response = await createSFRReport(
              selectedPatientData.patient.id,
              childReportData,
            );
          } else {
            response = await createSFRReport(selectedPatientData.patient.id, {
              ...reportData,
              [sfrKey]: currentDate,
            });
          }
          break;
        case 'iui':
          const iuiKey = buttonsKeysForReducer[activeStep];
          // Assuming you have a similar update function for QSA
          response = await createIUIReport(selectedPatientData.patient.id, {
            ...reportData,
            [iuiKey]: currentDate,
          });
          break;
        default:
          break;
      }

      if (!response) {
        setStepButtonsDisabled(false);
        dispatch(resetAndrologyData());
      } else {
        const mergedQsaData = {
          ...reportData,
          ...response[activeForm],
          patientDetails: {
            ...reportData.patientDetails,
            ...response[activeForm].patientDetails,
          },
          seminalFluidAnalysis: {
            ...reportData.seminalFluidAnalysis,
            ...response[activeForm].seminalFluidAnalysis,
          },
          spermAnalysis: {
            ...reportData.spermAnalysis,
            ...response[activeForm].spermAnalysis,
          },
          qualityAnalysis: {
            ...reportData.qualityAnalysis,
            ...response[activeForm].qualityAnalysis,
          },
          dfiDetails: {
            ...reportData.dfiDetails,
            ...response[activeForm].dfiDetails,
          },
          otherDetails: {
            ...reportData.otherDetails,
            ...response[activeForm].otherDetails,
          },
        };
        dispatch(setAndrologyData(activeForm, mergedQsaData));
        setActiveStep(index + 1);
      }
    }
    setStepButtonsDisabled(false);
  };
  const [previewContent, setPreviewContent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleDownloadReport = async (reportId) => {
    try {
      setPreviewContent(null);
      setStepButtonsDisabled(true);
      const res = await downloadReport(reportId);
      const previewContent = handlePreviewPDFFile({
        fileName: `${activeForm}-report-${selectedPatientData.patient.id}.pdf`,
        presignedUrl: res.payload.url,
      });
      setPreviewContent(previewContent);
      setShowModal(true);
      setStepButtonsDisabled(false);
    } catch (err) {
      setShowModal(false);
      setPreviewContent(null);
      setStepButtonsDisabled(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setPreviewContent(null);
  };

  const handleEmailReport = async (reportId) => {
    setStepButtonsDisabled(true);
    let sendReportFunction;

    if (activeForm === 'hsa') {
      sendReportFunction = sendHSAReport;
    } else if (activeForm === 'qsa') {
      sendReportFunction = sendQSAReport;
    } else if (activeForm === 'dfi') {
      sendReportFunction = sendDFIReport;
    } else if (activeForm === 'sfr') {
      sendReportFunction = sendSFRReport;
    } else if (activeForm === 'iui') {
      sendReportFunction = sendIUIReport;
    } else {
      toast.error('Invalid report type');
      return;
    }

    toast.promise(
      sendReportFunction(
        selectedPatientData.patient.id,
        reportData.id,
        reportId,
      ),
      {
        loading: 'Sending report...',
        success: (data) => {
          toast.success('Report sent successfully');
          dispatch(setAndrologyData(`${activeForm}.isReportDelivered`, true));
          setStepButtonsDisabled(false);
          setActiveStep(4);
          return 'Report sent successfully!';
        },
        error: (err) => {
          setStepButtonsDisabled(false);
          toast.error('Failed to send report');
          return 'Failed to send report';
        },
        duration: 300,
      },
    );
  };

  const getReportButtonText = () => {
    if (reportData && reportData.isReportStarted) {
      return 'Edit Report';
    } else {
      return 'Start Report';
    }
  };

  const freezingInventoryHandler = () => {
    setIsFreezingInventory(true);
    setSelectedSfrIdForFreezingInventory(reportData.id);
  };

  const pregnancyDetailsHandler = () => {
    setIsPregnancyDetails(true);
    setSelectedIuiIdForPregnancyDetails(reportData.id);
  };

  const collectMoreSampleHandler = async () => {
    setActiveStep(0);
    setStepDates({});
    setModifiedBy(null);
    setCreateChildReport(true);
    dispatch(setAndrologyData('sfr.isMoreSampleSelected', true));
    dispatch(setAndrologyData('sfr.parentId', reportData.id));
    dispatch(setAndrologyData('selectedProcess', 'SFR'));
    dispatch(setAndrologyData('isNewReport', true));
    // }
  };

  const viewHistoryHandler = () => {
    setShowHistoryOfChildReports(!showHistoryOfChildReports);
  };

  return (
    <>
      <StyledCard>
        <CardContent>
          <StyledBox>
            {/* Grid to align Address and Andrology Report in a single row */}
            <Grid container spacing={2}>
              {/* Address Section */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" gutterBottom>
                  {selectedPatientData.patient.partner.firstName}{' '}
                  {selectedPatientData.patient.partner.lastName}
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Phone: {selectedPatientData.patient.partner.phone}
                </Typography>
                <Typography variant="body1" gutterBottom>
                  MPID: {selectedPatientData.patient.upid}
                </Typography>
              </Grid>

              {/* Andrology Report Section */}
              <Grid
                item
                xs={12}
                sm={6}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <div>
                  <Typography
                    variant="h6"
                    gutterBottom
                  >{`Andrology Report ${activeForm.toUpperCase()}`}</Typography>
                  <Typography variant="body2">
                    {selectedPatientData.patient.referral.referringPhysician}
                  </Typography>
                </div>
                {!(
                  activeStep < steps.length - 1 ||
                  stepButtonsDisabled ||
                  !reportData?.reportId
                ) &&
                  activeForm === 'sfr' && (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '6px',
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '230px', height: 'fit-content' }}
                        onClick={() => {
                          freezingInventoryHandler();
                        }}
                        disabled={
                          activeStep < steps.length - 1 ||
                          stepButtonsDisabled ||
                          !reportData?.reportId
                        }
                      >
                        Freezing Inventory
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '230px', height: 'fit-content' }}
                        onClick={() => {
                          collectMoreSampleHandler();
                        }}
                        disabled={
                          activeStep < steps.length - 1 ||
                          stepButtonsDisabled ||
                          !reportData?.reportId
                        }
                      >
                        Collect More Samples
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{ minWidth: '230px', height: 'fit-content' }}
                        onClick={() => {
                          viewHistoryHandler();
                        }}
                        disabled={
                          activeStep < steps.length - 1 ||
                          stepButtonsDisabled ||
                          !reportData?.reportId
                        }
                      >
                        View History
                      </Button>
                    </div>
                  )}
                {!(
                  activeStep < steps.length - 1 ||
                  stepButtonsDisabled ||
                  !reportData?.reportId
                ) &&
                  activeForm === 'iui' && (
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ minWidth: '120px', height: 'fit-content' }}
                      onClick={() => {
                        pregnancyDetailsHandler();
                      }}
                      disabled={
                        activeStep < steps.length - 1 ||
                        stepButtonsDisabled ||
                        !reportData?.reportId
                      }
                    >
                      Pregnancy Details
                    </Button>
                  )}
              </Grid>
            </Grid>
            {
              // !showStepperAndFollowing &&
              reportData?.moreSampleIds?.length > 0 && (
                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: '10px', marginBottom: '30px' }}
                >
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                    }}
                  >
                    {reportData?.moreSampleIds
                    ?.slice() // Create a shallow copy of the array
                    .reverse() // Reverse the array
                    .map((sampleId, index) => {
                      const sfr = selectedPatientData?.patient?.sfr.find(
                        (sfr) => sfr.id === sampleId,
                      );

                      if (!sfr) return;
                      const showStepper = true;
                      const sampleCollectTime = new Date(sfr.sampleCollectedAt);
                      const receivedByLabTime = new Date(sfr.receivedByLabAt);

                      const localSteps = [
                        {
                          label: 'Sample Collected',
                          completed: !!sfr.sampleCollectedByUserId,
                          time: sampleCollectTime.toLocaleString(),

                          user: sfr?.sampleCollectedByUser
                            ? sfr?.sampleCollectedByUser?.firstName +
                              ' ' +
                              sfr?.sampleCollectedByUser?.lastName
                            : '',
                        },
                        {
                          label: 'Received by Lab',
                          completed: !!sfr.receivedByLabUserId,
                          user: sfr?.receivedByLabUser?.fileName
                            ? sfr?.receivedByLabUser?.firstName +
                              ' ' +
                              sfr?.receivedByLabUser?.lastName
                            : '',
                          time: receivedByLabTime.toLocaleString(),
                        },
                        {
                          label: 'Report Generated',
                          completed: !!sfr.reportId,
                        },
                      ];

                      return (
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '10px',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              gap: '4px',
                              alignItems: 'center',
                            }}
                          >
                            <Button
                              variant="contained"
                              color="primary"
                              sx={{
                                minWidth: '120px',
                                maxWidth: 'fit-content',
                              }}
                              disabled={!sfr?.reportId}
                              onClick={() => {
                                handleDownloadReport(sfr?.reportId);
                              }}
                            >
                              Download Report
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              sx={{
                                minWidth: '120px',
                                maxWidth: 'fit-content',
                              }}
                              disabled={!sfr?.reportId}
                              onClick={() => handleEmailReport(sfr?.reportId)}
                            >
                              Send Email
                            </Button>
                            {sfr.id === activeChildReport?.id ? (
                              <span
                                style={{ color: 'green', fontWeight: 'bold' }}
                              >
                                *
                              </span>
                            ) : null}
                          </div>
                          <div>
                              <p style={{ fontSize: '13px' ,marginBottom:'0px'}}>
                                ( Report Id: {`${sfr.id}`},{' '}
                                {/* Sample At: {new Date(sfr.sampleCollectedAt).toISOString().split('T')[0]}  */}
                                Sample At: {sfr.sampleCollectedAt}{' '}
                                )
                              </p>
                            </div>
                          {showHistoryOfChildReports && (
                            <Stepper alternativeLabel>
                              {localSteps.map((step, stepIndex) => (
                                <Step
                                  key={step.label}
                                  completed={step.completed}
                                >
                                  <StepLabel>
                                    <Box textAlign="center">
                                      <Typography variant="body1">
                                        {step.label}
                                      </Typography>
                                      {stepIndex < 2 && (
                                        <>
                                          <Typography
                                            variant="caption"
                                            display="block"
                                          >
                                            {step?.time
                                              ? step?.time?.toLocaleString()
                                              : ''}
                                          </Typography>
                                          <Typography
                                            variant="caption"
                                            display="block"
                                          >
                                            {step?.user ? step?.user : ''}
                                          </Typography>
                                        </>
                                      )}
                                    </Box>
                                  </StepLabel>
                                </Step>
                              ))}
                            </Stepper>
                          )}
                        </div>
                      );
                    })}
                  </Grid>
                </Grid>
              )
            }

            {!reportData?.moreSampleIds?.length && (
              <div
                style={
                  reportData?.moreSampleIds?.length > 0
                    ? {
                        // backgroundColor: 'azure',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        padding: '24px',
                        paddingTop: '40px',
                      }
                    : {}
                }
              >
                {/* Stepper */}
                <Stepper activeStep={activeStep} alternativeLabel>
                  {steps.map((label, index) => (
                    <Step key={label}>
                      <StepLabel>
                        <Box textAlign="center">
                          <Typography variant="body1">{label}</Typography>
                          {stepDates[index] && (
                            <Typography variant="caption" display="block">
                              {stepDates[index]}
                            </Typography>
                          )}
                          {index === 0 && (
                            <Typography variant="caption" display="block">
                              {stepDates[index]
                                ? reportData?.sampleCollectedByUser
                                  ? `${reportData?.sampleCollectedByUser.firstName} 
                          ${reportData?.sampleCollectedByUser.lastName}`
                                  : modifiedBy
                                : ''}
                            </Typography>
                          )}
                          {index === 1 && (
                            <Typography variant="caption" display="block">
                              {stepDates[index]
                                ? reportData?.receivedByLabUser
                                  ? `${reportData?.receivedByLabUser.firstName} 
                          ${reportData?.receivedByLabUser.lastName}`
                                  : modifiedBy
                                : ''}
                            </Typography>
                          )}
                        </Box>
                      </StepLabel>
                    </Step>
                  ))}
                </Stepper>

                {/* Buttons aligned to the right */}
                <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
                  {buttonsForSteps.map((step, index) => (
                    <Button
                      key={index}
                      variant="contained"
                      color="primary"
                      sx={{ minWidth: '120px' }}
                      onClick={() => handleStepComplete(index)}
                      disabled={activeStep !== index || stepButtonsDisabled} // Enable only if step is not completed
                    >
                      {step}
                    </Button>
                  ))}

                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ minWidth: '120px' }}
                    onClick={() => {
                      dispatch(setAndrologyData(`${activeForm}`, reportData));
                      setSelectedProcess(activeForm);
                      setIsReportSelected(true);
                    }}
                    disabled={activeStep < 2 || reportData?.reportId}
                  >
                    {getReportButtonText()}
                  </Button>

                  {reportData?.reportId && (
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ minWidth: '120px' }}
                      onClick={() => handleDownloadReport(reportData?.reportId)}
                      disabled={activeStep < 2}
                    >
                      Download Report
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ minWidth: '120px' }}
                    disabled={
                      activeStep < steps.length - 1 ||
                      stepButtonsDisabled ||
                      !reportData?.reportId
                    }
                    onClick={handleEmailReport}
                  >
                    Send Email
                  </Button>
                </Box>
              </div>
            )}
          </StyledBox>
        </CardContent>
      </StyledCard>
      <Modal show={showModal} onHide={handleCloseModal} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>File Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>{previewContent}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
